import { render, staticRenderFns } from "./LoopDetails.vue?vue&type=template&id=2ff80446&scoped=true&"
import script from "./LoopDetails.vue?vue&type=script&lang=js&"
export * from "./LoopDetails.vue?vue&type=script&lang=js&"
import style0 from "./LoopDetails.vue?vue&type=style&index=0&id=2ff80446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff80446",
  null
  
)

export default component.exports